import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import type { FormSaveCancelActions } from '../../../../components/form/FormSaveCancelButtons.tsx';

export type PersonEditFormActions = FormSaveCancelActions;

type PersonEditFormActionsContextValue = {
  actions: PersonEditFormActions | null;
  registerActions: (actions: PersonEditFormActions | null) => void;
};

const PersonEditFormActionsContext = createContext<PersonEditFormActionsContextValue | null>(null);

export function PersonEditFormActionsProvider({ children }: { children: ReactNode }) {
  const [actions, setActions] = useState<PersonEditFormActions | null>(null);

  const registerActions = useCallback((nextActions: PersonEditFormActions | null) => {
    setActions(nextActions);
  }, []);

  const value = useMemo(
    () => ({
      actions,
      registerActions,
    }),
    [actions, registerActions],
  );

  return <PersonEditFormActionsContext.Provider value={value}>{children}</PersonEditFormActionsContext.Provider>;
}

export function usePersonEditFormActions() {
  const context = useContext(PersonEditFormActionsContext);

  if (!context) {
    throw new Error('usePersonEditFormActions must be used within PersonEditFormActionsProvider');
  }

  return context;
}
